<template>
    <main>
        <section class="hero">
            <div class="lg:tw-container tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-flex-row lg:tw-items-start lg:tw-justify-between">
                <div class="info-container">
                    <div class="logo">
                        <img src="~@/assets/img/logo.svg">
                    </div>
                    <div class="text">
                        <h2>Notre réponse efficace aux</h2>
                        <h1>problèmes<br>d’humidité !</h1>
                        <h3>Remontées capillaires, cloques et salpêtre, infiltrations, condensations, moisissures, mérules…</h3>
                        <ul class="tw-hidden lg:tw-block">
                            <li>15 agences, dont 1 près de chez vous +</li>
                            <li>+ de 17 000 références</li>
                            <li>30 années d’expérience</li>
                            <li>Made in France</li>
                        </ul>
                    </div>
                </div>
                <div class="form-container">
                    <Form v-if="!$store.state.formSuccess && !$store.state.formError" />
                    <FormSuccess v-if="$store.state.formSuccess && !$store.state.formError" />
                    <FormError v-if="$store.state.formError && !$store.state.formSuccess" />
                </div>
            </div>
        </section>
        <section class="solutions">
            <div class="tw-container">
                <h2>Nos solutions</h2>
                <p><b>Nos solutions sont performantes, écologiques et non invasives et ne nécessitent pas d’entretien particulier.</b><br class="lg:tw-hidden"> Elles ont reçu un avis favorable Qualiconsult pour leur fiabilité et leur durée de vie. Nos solutions sont garanties 10 ans pour vous permettre de bénéficier d’une maison saine pour longtemps.</p>
                <p>Les bâtiments anciens sont particulièrement vulnérables à l’humidité et aux remontées capillaires. La présence d’humidité dans les murs fragilise le bâti et altère votre confort.</p>
                <div class="products">
                    <!-- Product 1 -->
                    <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-6">
                        <div class="product">
                            <img src="~@/assets/img/1.png">
                        </div>
                        <div class="info">
                            <h4>MUR-TRONIC 2</h4>
                            <small>LA MEILLEURE SOLUTION CONTRE LES REMONTÉES CAPILLAIRES</small>
                            <p>Mur-Tronic 2 est un boîtier autonome qui s’alimente grâce à l’énergie produite par la friction de l’eau sous-terraine. Garanti 10 ans pour une durée de vie supérieure à 50 ans, il s’installe facilement, sans intervention sur la maçonnerie.</p>
                            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mx-auto">
                                <ul>
                                    <li>Des murs secs en 6 à 8 mois</li>
                                    <li>Durée de vie supérieure à 50 ans</li>
                                </ul>
                                <ul>
                                    <li>Garanti 10 ans</li>
                                    <li>Fabriqué en France</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Product 2 -->
                    <div class="tw-flex tw-flex-col lg:tw-flex-row-reverse lg:tw-gap-6">
                        <div class="product">
                            <img src="~@/assets/img/2.png">
                        </div>
                        <div class="info">
                            <h4>AQUA-RAID</h4>
                            <small>LE TRAITEMENT LE PLUS PUISSANT CONTRE LES REMONTÉES CAPILLAIRES</small>
                            <p>Aqua-Raid est un boîtier branché sur secteur pour un assèchement plus rapide de vos murs. Garanti 10 ans et d’une durée de vie supérieure à 20 ans, il est efficace dès les premiers mois, sans produits chimiques et sans intervention sur la maçonnerie.</p>
                            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mx-auto">
                                <ul>
                                    <li>Des murs secs en 6 à 8 mois</li>
                                    <li>Durée de vie supérieure à 20 ans</li>
                                </ul>
                                <ul>
                                    <li>Garanti 10 ans</li>
                                    <li>Fabriqué en France</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Product 3 -->
                    <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-6">
                        <div class="product">
                            <img src="~@/assets/img/3.png">
                        </div>
                        <div class="info">
                            <h4>MUR-TRONIC 1</h4>
                            <small>LA PREMIÈRE GÉNÉRATION DES APPAREILS MUR-TRONIC</small>
                            <p>Mur-Tronic 1 est le boîtier première génération Mur-Tronic. Moins rapide mais tout aussi efficace, il est lui aussi garanti 10 ans et se décline en 7 appareils selon la puissance et la surface à traiter.</p>
                            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mx-auto">
                                <ul>
                                    <li>Des murs secs en 16 à 18 mois</li>
                                    <li>Durée de vie supérieure à 50 ans</li>
                                </ul>
                                <ul>
                                    <li>Garanti 10 ans</li>
                                    <li>Fabriqué en France</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <button class="btn-page tw-mx-auto lg:tw-hidden" v-scroll-to="'.form'">Contactez-nous</button>
                </div>
            </div>
        </section>
        <section class="steps">
            <div class="tw-container">
                <h2>Les étapes de notre <br class="lg:tw-hidden">intervention</h2>
                <div class="tw-grid tw-grid-cols-1 tw-gap-5 lg:tw-grid-cols-3 lg:tw-gap-8">
                    <div>
                        <div class="image">
                            <img src="~@/assets/img/grid-1.jpg">
                        </div>
                        <h3>DIAGNOSTIC</h3>
                        <p>Diagnostic Gratuit : Un expert Mur-Tronic se déplace chez vous pour identifier la nature et le degré de gravité de votre problème et établir un devis.</p>
                    </div>
                    <div>
                        <div class="image">
                            <img src="~@/assets/img/grid-2.jpg">
                        </div>
                        <h3>INSTALLATION</h3>
                        <p>Installation de votre solution Mur-Tronic. Un chantier rapide, des solutions respectueuses de l’environnement et durables.</p>
                    </div>
                    <div>
                        <div class="image">
                            <img src="~@/assets/img/grid-3.jpg">
                        </div>
                        <h3>SUIVI</h3>
                        <p>Suivi : Nous effectuons un relevé référence du taux d’humidité de vos murs et, 8-10 mois plus tard, un nouveau relevé pour suivre la progression de l’assèchement de vos murs.</p>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
import FormError from '@/components/FormError.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
        FormError,
    },
};
</script>
